var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"callCenter"}},[_c('div',{staticClass:"udeskBtn",attrs:{"id":"udeskBtn"},on:{"click":_vm.openUdesk}},[_c('img',{staticClass:"footer-fun-img",attrs:{"src":"https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/footer-call1.png"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }